import { Component, Inject, Optional, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Usuario } from 'app/main/models/usuario.model';
import { UsersService } from '../../../services/users.service';
import {TranslateService} from '@ngx-translate/core';
import {FormControl} from '@angular/forms';
import {map, startWith} from 'rxjs/operators';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-dialog-box',
  templateUrl: './select-dialog-box.component.html',
  styleUrls: ['./select-dialog-box.component.scss']
})

export class SelectUsuarioDialogBoxComponent {

  filteredUsuarios: Observable<Usuario[]>;
  myControl = new FormControl();
  usuario : Usuario = null;
  usuarios: Usuario[] = [];
  action: string;
  LOCAL_DATA: any;

  constructor(
    public dialogRef: MatDialogRef<SelectUsuarioDialogBoxComponent>,
    private usuariosService: UsersService,
    public translate: TranslateService,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
      this.action = data.action;
      this.usuario = data.obj;
      this.LOCAL_DATA = data.obj;
      this.myControl.setValue(this.LOCAL_DATA);
      this.usuarios = data.usuarios;
      if(this.usuarios==null){
        this.usuariosService.getAll(0,1000).pipe().subscribe(req => {
          this.usuarios = req.body.map( usuario => {
            console.log(usuario);
            return {
              id: usuario.id,
              nombreCompleto: usuario.nombreCompleto,
              correoElectronico: usuario.correoElectronico

            };
          });

          this.filteredUsuarios = this.myControl.valueChanges.pipe(
            startWith(''),
            map(value => this._filter(value))
          );
        });
      }else{
        this.filteredUsuarios = this.myControl.valueChanges.pipe(
          startWith(''),
          map(value => this._filter(value))
        );
      }
  }

  private _filter(value: String): Usuario[] {
      if(typeof value === "string"){
        const filterValue = value.toLowerCase();
        return this.usuarios.filter(option => option.nombre.toLowerCase().includes(filterValue));
      }
      //return this.controles.filter(option => option.nombre.toLowerCase().indexOf(filterValue) === 0);

  }

  displayFn(value?: Usuario) {
    return value ? this.usuarios.find(_ => _.id === value.id).nombreCompleto : (value!=null ? value.nombreCompleto: undefined);
  }


  doAction(): void{
    console.log('im here');
    this.dialogRef.close({event: this.action , data: this.usuario});
  }

  closeDialog(): void{
    this.dialogRef.close({event: 'Cancel'});
  }


  setLocal(option):void{
    this.LOCAL_DATA.nombre = option.nombre;
  }

  ngOnInit(): void {


  }

}
